import axios, { AxiosRequestConfig } from "axios";

class ApiClient {
  // Use the global axios instance directly instead of creating a new one
  
  constructor() {
    // The global axios instance already has all interceptors and baseURL configured
  }

  async get<T = any>(url: string, config?: AxiosRequestConfig) {
    return axios.get<T>(url, config);
  }

  async post<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    return axios.post<T>(url, data, config);
  }

  async put<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    return axios.put<T>(url, data, config);
  }

  async patch<T = any>(url: string, data?: any, config?: AxiosRequestConfig) {
    return axios.patch<T>(url, data, config);
  }

  async delete<T = any>(url: string, config?: AxiosRequestConfig) {
    return axios.delete<T>(url, config);
  }
}

export const apiClient = new ApiClient();